import React from 'react';
import { LanguageProvider } from '../context/LanguageContext';

const withLanguageProvider = (Component) => (props) => (
  <LanguageProvider>
    <Component {...props} />
  </LanguageProvider>
);

export default withLanguageProvider;
